export default __webpack_public_path__ + "static/fish3-fa2a352ddac02ac931b04b7660020a47.svg";